import { Box, Link, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { stringUtils } from '@verifime/utils';
import { ColoredIcon } from '../ColoredIconAndChip';

export default function DownloadLink({
  filename,
  url,
}: Readonly<{
  filename: string;
  url: string;
}>) {
  return (
    <Link
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ display: 'flex', gap: tokens.spacing2xs }}
    >
      <Typography>{stringUtils.ellipsis(filename || url, 'middle')}</Typography>
      <Box>
        <ColoredIcon iconName="openInNewRounded" />
      </Box>
    </Link>
  );
}
